import request from '@/utils/request'
const url = '/admin/attachment_group/'
const api = {
  Query(data) {
    return request({
      url: url + 'Query',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: url + 'delete',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: url + 'SaveOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: url + 'SaveOrUpdate',
      method: 'post',
      data
    })
  }
}
export default api
